export class BaseComponent {
    constructor(compRef) {
        this.compRef = compRef;
    }
}
//# sourceMappingURL=BaseComponent.js.map